module.exports = __webpack_public_path__ + "img/01020401.0b9e8480.svg";